import App from 'app/app.js';
import 'app/controller/HomeCtrl.js';

function LtJobLoadFailedDrawer() {
  return {
    restrict: 'E',
    scope: {
      drawerTheme: '@',
      iconName: '@',
      drawerTitleKey: '@',
      drawerDescKey: '@',
      cancelKey: '@',
      onCancel: '&',
      onEmit: '&',
      buttonKey: '@'
    },
    template:
      '    <div class="modal-body" ng-init="failCtrl.init()" lt-drawer="failCtrl.visible" lt-drawer-cancellation="failCtrl.close(); onCancel()">' +
      '        <div class="failed-job {{drawerTheme}}">' +
      '           <div class="main">' +
      '               <lt-icon name="fa-sharp-solid-times" ng-click="failCtrl.close()"></lt-icon>' +
      '               <div class="icon">' +
      '                   <span class="{{iconName}}"></span>' +
      '               </div>' +
      '               <div class="title" lt-translate="{{drawerTitleKey}}"></div>' +
      '           </div>' +
      '           <div class="detail">' +
      '               <div class="desc" lt-translate="{{drawerDescKey}}"></div>' +
      '               <button ng-show="buttonKey" lt-translate="{{buttonKey}}" class="btn" ng-click="onEmit()"></button>' +
      '               <div class="close-action" lt-translate="{{cancelKey}}" ng-click="failCtrl.close(); onCancel()"></div>' +
      '           </div>' +
      '        </div>' +
      '    </div>',
    controller: function () {
      this.visible = false;

      this.init = function () {
        this.visible = true;
      };

      this.close = function () {
        this.visible = false;
      };
    },
    controllerAs: 'failCtrl'
  };
}

App.directive('ltJobLoadFailedDrawer', [LtJobLoadFailedDrawer]);
